module.exports = __webpack_public_path__ + "img/nukcafe_icon.f3a38a49.png";